import { Flex } from '@/components/base';
import BaseLabel from '@/components/BaseLabel/BaseLabel';
import { MainText } from '@/components/Typography/NamedTypo';
import useColor from '@/hooks/domain/useColor';

type Props = {
  tag: TagT;
  parentNames: string[];
};

const TagOptionNode = (props: Props) => {
  const tag = props.tag;
  const color = useColor();
  const NameNode = () => {
    const parentPath = props.parentNames.join(' / ');

    if (props.parentNames.length > 0) {
      return (
        <MainText dim>
          {parentPath} / <MainText>{tag.name}</MainText>
        </MainText>
      );
    }
    return tag.name;
  };
  return (
    <Flex>
      <BaseLabel name={<NameNode />} color={color.profile[tag.color - 1]} />
    </Flex>
  );
};

export default TagOptionNode;
